import { hasWishlistItem, toggleWishlistItem, WISHLIST_KEY } from '@theme/wishlist-store';

/**
 * Heart button that saves or removes one product from the wishlist.
 * Markup: <s-wishlist-toggle id data-handle data-url data-title data-image data-price data-label-add data-label-remove data-label-saved data-label-removed>
 *   <button commandfor="{id}" command="--toggle" aria-pressed="false">…</button>
 */
class WishlistToggle extends HTMLElement {
  connectedCallback() {
    this.button = this.querySelector('button');
    this.onCommand = (event) => {
      if (event.command !== '--toggle') return;
      const added = toggleWishlistItem({
        handle: this.dataset.handle,
        url: this.dataset.url,
        title: this.dataset.title,
        image: this.dataset.image,
        price: this.dataset.price,
      });
      this.announce(added ? this.dataset.labelSaved : this.dataset.labelRemoved);
    };
    this.onChange = () => this.sync();
    this.onStorage = (event) => {
      if (event.key === WISHLIST_KEY) this.sync();
    };
    this.addEventListener('command', this.onCommand);
    window.addEventListener('wishlist:change', this.onChange);
    window.addEventListener('storage', this.onStorage);
    this.sync();
  }

  disconnectedCallback() {
    this.removeEventListener('command', this.onCommand);
    window.removeEventListener('wishlist:change', this.onChange);
    window.removeEventListener('storage', this.onStorage);
  }

  sync() {
    if (!this.button) return;
    const saved = hasWishlistItem(this.dataset.handle);
    this.button.setAttribute('aria-pressed', String(saved));
    const label = saved ? this.dataset.labelRemove : this.dataset.labelAdd;
    if (label) this.button.setAttribute('aria-label', label);
  }

  announce(message) {
    const region = this.querySelector('[data-wishlist-status]');
    if (region && message) region.textContent = message;
  }
}

if (!customElements.get('s-wishlist-toggle')) customElements.define('s-wishlist-toggle', WishlistToggle);
